import { useContext } from "react";
import { Auth0Context } from "../contexts/Auth0";

export const useAuth0 = () => useContext(Auth0Context);
